module.exports = __webpack_public_path__ + "img/button-doctorsearch.1a708ad3.png";